<template>
  <div class="main-container">
    <div class="bread" v-if="!!$route.query.recommend">
      <router-link :to="{ name: 'Index' }">首页</router-link>
      <span class="slash">/</span>
      <router-link
        :to="{
          name: 'IndexRecommendPeriods',
          query: {
            title: $route.query.title,
            recommend: $route.query.recommend,
          },
        }"
      >
        {{ $route.query.title }}
      </router-link>
      <span class="slash">/</span>
      <span class="current">{{ detail.name }}</span>
    </div>
    <div class="bread" v-else>
      <router-link :to="{ path: nav.url }">{{ nav.name }}</router-link>
      <span class="slash">/</span>
      <span class="current">{{ detail.name }}</span>
    </div>
    <template v-if="detail.status == 1">
      <div class="cover-wrap">
        <ImageClip
          class="cover f-left"
          :src="detail.cover_img"
          :width="420"
          :height="279"
          :radius="5"
        ></ImageClip>
        <div class="right f-left">
          <div class="title">{{ detail.name }}</div>
          <div class="periods-detail-info">
            <span>
              <span>可用时间：</span>
              <span v-if="detail.dispatch_start_time == 0">长期</span>
              <span v-else>
                {{ detail.dispatch_start_time | tsFormat('yyyy年MM月dd日') }}-{{
                  detail.dispatch_end_time | tsFormat('yyyy年MM月dd日')
                }}
              </span>
            </span>
            <span class="periods-detail-vline">|</span>
            <span>{{ detail.pack_num }}课时</span>
            <span class="periods-detail-vline">|</span>
            <span>{{ detail.teaching_type | enum('TeachingType') }}</span>
          </div>
          <div class="periods-detail-info">
            <template v-if="detail.classify_name">
              <span>{{ detail.classify_name }}</span>
            </template>
            <span v-if="detail.classify_name && detail.grade_name" class="periods-detail-vline">
              |
            </span>
            <span>{{ detail.grade_name }}</span>
          </div>
          <div class="periods-detail-hours_wrap">
            <div class="periods-detail-hours">
              <div>课时明细：</div>
              <div class="periods-detail-hours_items">
                <div class="periods-detail-hours_odd">
                  <div
                    class="periods-detail-hours_item"
                    v-for="(item, index) in timesOdd"
                    :key="index"
                  >
                    <span style="margin-right: 10px">{{ item.sub_name }}</span>
                    <span>{{ item.class_hours }}课时</span>
                  </div>
                </div>
                <div>
                  <div
                    class="periods-detail-hours_item"
                    v-for="(item, index) in timesEven"
                    :key="index"
                  >
                    <span style="margin-right: 10px">{{ item.sub_name }}</span>
                    <span>{{ item.class_hours }}课时</span>
                  </div>
                </div>
              </div>
            </div>
            <CurrencyNew
              :price="detail.sale_price"
              :priceUnderline="
                detail.original_price == detail.sale_price ? 0 : detail.original_price
              "
              :isUnderlineLeft="false"
            ></CurrencyNew>
          </div>
          <div class="periods-detail-footer">
            <a @click="goToBuy" class="btn" v-if="detail.is_stock == 1"> 立即报名 </a>
            <a class="btn btn-soldout" v-else>已售罄</a>
            <a
              class="btn btn-blank"
              @click="dialogShow = true"
              v-if="detail.consulting_service_type == 2"
            >
              立即咨询
            </a>
            <span class="periods-detail-sales">
              {{ detail.sales_num + detail.sales_base }}人已购买
            </span>
          </div>
        </div>
      </div>
      <div class="periods-detail-main">
        <div class="periods-detail-tabs">
          <BlockTabs :items="tabs" currentClass="bold5" isNew></BlockTabs>
          <Rich class="tab-content-detail" v-html="detail.content_detail"></Rich>
          <div v-if="detail.content_detail == ''" class="empty">
            <img src="@/assets/images/homework/empty.png" />
            <div class="text">暂无数据</div>
          </div>
        </div>
        <div class="periods-detail-recommend" v-if="recommends.length > 0">
          <div class="periods-detail-recommend_title">推荐课时包</div>
          <PeriodsItem
            v-for="recommend in recommends"
            :key="recommend.id"
            :item="recommend"
            :coverWidth="298"
            :coverHeight="199"
          ></PeriodsItem>
        </div>
      </div>
      <el-dialog class="dialog" :visible.sync="dialogShow" append-to-body width="260px">
        <div class="dialog-title">{{ detail.consult_title }}</div>
        <img class="img" :src="detail.consult_image" />
        <div class="tip">{{ detail.consult_brief }}</div>
        <img class="close" @click="dialogShow = false" src="@/assets/images/common/close@2x.png" />
      </el-dialog>
    </template>
    <CourseSoldOut
      v-if="detail.status == 2 || detail.status == 3"
      router-name="Periods"
      name="课时包"
    ></CourseSoldOut>
    <PackageService
      :treatyContent="treatyContent"
      @onConfirm="onConfirm"
      :showModal.sync="showModal"
    />
  </div>
</template>
<script>
import PeriodsItem from '@/modules/stu/components/periods/PeriodsItem.vue';
import CourseSoldOut from '../../components/CourseSoldOut.vue';
import PackageService from './components/PackageService';

export default {
  name: 'PeriodsDetail',
  components: { PeriodsItem, CourseSoldOut, PackageService },
  data() {
    return {
      isSet: true,
      treatyContent: '',
      showModal: false,
      detail: { pack_item: [] },
      dialogShow: false,
      tabs: [{ id: 1, name: '课时包介绍' }],
      recommends: [],
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    navigates() {
      return this.$store.state.navigates;
    },
    nav() {
      let nav = this.navigates.filter((n) => n.id == this.$route.query.nav)[0];
      if (nav && nav.url != '/index') {
        nav = { ...nav };
        let url = nav.url;
        if (url.indexOf('?') < 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += 'nav=' + nav.id;
        nav.url = url;
        return nav;
      }
      return { name: '课时包', url: '/periods' };
    },
    timesOdd() {
      return this.detail.pack_item.filter((t, index) => index % 2 == 0);
    },
    timesEven() {
      return this.detail.pack_item.filter((t, index) => index % 2 == 1);
    },
  },
  watch: {
    $route() {
      this.getDetail();
    },
  },
  async created() {
    this.getDetail();
    let data = await this.$http.get('/api/app/classpack/packlist/index', {
      limit: 999999,
      is_recommend: 1,
    });
    this.recommends = data.list.filter((t) => t.id != this.id);
    this.getSwitch();
  },
  methods: {
    async getSwitch() {
      const res = await this.$http.get('/api/app/config/class_pack_open');
      this.isSet = res.class_pack_open == 1;
      if (this.isSet) {
        const data = await this.$http.get('/api/app/config/class_pack_contract');
        this.treatyContent = data.class_pack_contract || '';
      }
    },
    onConfirm() {
      this.toBuy();
    },
    async getDetail() {
      this.detail = await this.$http.get('/api/app/classpack/packdetail/' + this.id);
    },
    toBuy() {
      this.$router.push({
        name: 'OrderConfirm',
        query: {
          id: this.id,
          type: 17,
        },
      });
    },
    goToBuy() {
      if (this.isSet) {
        this.showModal = true;
        return;
      }
      this.toBuy();
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/modules/stu/css/periods-detail.scss';
</style>
